import {
  WindowWidthContextProvider,
  useWindowWidthContext
} from './WindowWidthContext';

export { useWindowWidthContext, WindowWidthContextProvider };
